// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file penumbra/core/component/funding/v1/funding.proto (package penumbra.core.component.funding.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { Amount } from "../../../num/v1/num_pb.js";
/**
 * Funding component configuration data.
 *
 * @generated from message penumbra.core.component.funding.v1.FundingParameters
 */
export class FundingParameters extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.funding.v1.FundingParameters";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new FundingParameters().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FundingParameters().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FundingParameters().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FundingParameters, a, b);
    }
}
/**
 * Genesis data for the funding component.
 *
 * @generated from message penumbra.core.component.funding.v1.GenesisContent
 */
export class GenesisContent extends Message {
    /**
     * @generated from field: penumbra.core.component.funding.v1.FundingParameters funding_params = 1;
     */
    fundingParams;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.funding.v1.GenesisContent";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "funding_params", kind: "message", T: FundingParameters },
    ]);
    static fromBinary(bytes, options) {
        return new GenesisContent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenesisContent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenesisContent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenesisContent, a, b);
    }
}
/**
 * Indicates that a funding stream reward was paid.
 *
 * @generated from message penumbra.core.component.funding.v1.EventFundingStreamReward
 */
export class EventFundingStreamReward extends Message {
    /**
     * The recipient of the funding stream reward.
     * This is a string value for future extensibility.
     * Currently it will be either "community-pool"
     * or an address.
     *
     * @generated from field: string recipient = 1;
     */
    recipient = "";
    /**
     * The epoch for which the reward was paid.
     *
     * @generated from field: uint64 epoch_index = 2;
     */
    epochIndex = protoInt64.zero;
    /**
     * The amount of the reward, in staking tokens.
     *
     * @generated from field: penumbra.core.num.v1.Amount reward_amount = 3;
     */
    rewardAmount;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.funding.v1.EventFundingStreamReward";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "recipient", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "epoch_index", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 3, name: "reward_amount", kind: "message", T: Amount },
    ]);
    static fromBinary(bytes, options) {
        return new EventFundingStreamReward().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EventFundingStreamReward().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EventFundingStreamReward().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EventFundingStreamReward, a, b);
    }
}
